export enum RankingType {
  Individual = 'individual',
  Company = 'company',
}
